export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/homeInspection.04203ef2.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};